import _constants from '@shared/msp/constants.js';
import podismo from '@config/sport/podismo/scheda.json';
import ciclismo from '@config/sport/ciclismo/scheda.json';
import nuoto from '@config/sport/nuoto/scheda.json';
import sci from '@config/sport/sci/scheda.json';
import palestra from '@config/sport/palestra/scheda.json';
import custom from '@config/sport/custom/scheda.json';
import alimentazione from '@config/sport/alimentazione/scheda.json';

// src/config/sport/<codice>/scheda.json per sport_id, con import statici: il modulo è usato anche
// dal mobile (webpack), dove import.meta.glob di schedaConfig.js (frontend-v3) non esiste.
// Un nuovo sport con scheda.json va aggiunto qui.
const schede = { podismo, ciclismo, nuoto, sci, palestra, custom, alimentazione };

/** Config della scheda dello sport ({} se lo sport non ne ha una). */
export function schedaSport(sport_id) {
    const codice = Object.keys(_constants.sport_id).find(k => _constants.sport_id[k] === +sport_id);
    return schede[codice] ?? {};
}
